import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { compose, height, maxHeight, maxWidth, themeGet, width } from 'styled-system';

import h24LogoSvg from 'common/assets/images/home-24-logo.svg';
import { H24_IMG_HEIGHT, H24_IMG_WIDTH } from 'common/constants/logo';
import { useLocalization } from 'common/providers/LocaleProvider';
import { focusOutlineCSSWithOffset } from 'common/theme/styles';
import { trackLogoClick } from '../tracking';

const LogoLink = styled.a`
  display: flex;
  border-radius: ${themeGet('radii.medium')};
  ${focusOutlineCSSWithOffset};
`;

const BrandLogo = styled.img(compose(width, maxWidth, height, maxHeight));

const brandLogoStyles: ComponentProps<typeof BrandLogo> = {
  src: h24LogoSvg,
  width: H24_IMG_WIDTH,
  maxWidth: H24_IMG_WIDTH,
  height: H24_IMG_HEIGHT,
  maxHeight: H24_IMG_HEIGHT,
};

const Logo = () => {
  const { t, prefix } = useLocalization();

  return (
    <LogoLink href={prefix(t('h24_home_url'))} onClick={() => trackLogoClick()}>
      <BrandLogo data-testid="brand-logo" alt={t('h24_logo_alt_title')} {...brandLogoStyles} />
    </LogoLink>
  );
};

export default Logo;
